module.exports = __webpack_public_path__ + "static/media/email-send.76f84d26.svg";